const routes = [
  {
    path: '',
    component: () => import('@/views/eden/disputeresolution/Wrapper.vue'),
    children: [
      {
        path: '/eden/disputeResolution',
        name: 'edenDisputeResolution',
        component: () => import('@/views/eden/disputeresolution/Main.vue'),
      },
      {
        path: '/eden/disputeResolution/:id',
        name: 'edenDisputeResolutionDetails',
        component: () => import('@/views/eden/disputeresolution/Details.vue'),
      }, 
    ],
  },
]

export default routes
